var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-sm text-center text-secondary-500 dark:text-darkblue-200"},[_vm._v("©"+_vm._s(_vm.currYear)+" ZeroComa - "+_vm._s(_vm.version))])}
var staticRenderFns = []

export { render, staticRenderFns }